import styled from 'styled-components';
import { getColor } from 'common/constants/_colors';
import Text from 'components/base/Text';

export const StuckHeader = styled(Text)`
  color: ${getColor('gray')};
  letter-spacing: 0.01071em;
  line-height: 3rem;
  min-width: 6rem;
`;
